import { NavLink, useNavigate } from "react-router-dom";
import { Bell, BookOpen, ClipboardCheck, Dumbbell, History, LayoutDashboard, LogOut, Menu, MessageCircle, Settings, UserCircle, Users, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const coachLinks = [
  ["/coach", "Panoramica", LayoutDashboard], ["/coach/athletes", "Atleti", Users],
  ["/coach/exercises", "Esercizi", Dumbbell], ["/coach/plans", "Schede", BookOpen],
  ["/coach/checks", "Check atleti", ClipboardCheck], ["/coach/chat", "Chat", MessageCircle],
  ["/coach/profile", "Profilo", UserCircle], ["/coach/notifications", "Preferenze", Settings],
];
const athleteLinks = [["/athlete", "La mia scheda", Dumbbell], ["/athlete/history", "Storico", History],
  ["/athlete/chat", "Chat trainer", MessageCircle], ["/athlete/profile", "Profilo", UserCircle]];
const absoluteMedia = (value, version = "1") => value ? `${api.defaults.baseURL.replace(/\/api$/, "")}${value}?v=${encodeURIComponent(version)}` : null;

export function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState({ unread: 0, items: [] });
  const [noticeOpen, setNoticeOpen] = useState(false);
  const links = user.role === "coach" ? coachLinks : athleteLinks;

  useEffect(() => {
    const load = () => api.get("/notifications").then(({ data }) => setNotifications(data)).catch(() => {});
    load(); const timer = window.setInterval(load, 10000); return () => window.clearInterval(timer);
  }, []);
  const signOut = async () => { await logout(); window.location.replace("/"); };
  const showNotices = async () => {
    setNoticeOpen((value) => !value);
    if (notifications.unread) {
      try {
        await api.patch("/notifications/read");
        setNotifications((value) => ({ ...value, unread: 0 }));
      } catch {
        setNoticeOpen(false);
      }
    }
  };

  return <div className="app-shell" data-testid="authenticated-app-shell">
    <aside className={`sidebar ${open ? "sidebar-open" : ""}`} data-testid="primary-navigation">
      <div className="brand sidebar-brand" data-testid="brand-name"><img src="/cali-hero-logo.png" alt="Cali Hero" data-testid="sidebar-cali-hero-logo" /></div>
      <button className="mobile-close" onClick={() => setOpen(false)} data-testid="close-navigation-button"><X /></button>
      <nav>{links.map(([to, label, Icon]) => <NavLink key={to} to={to} end={to.split("/").length === 2}
        onClick={() => setOpen(false)} data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-")}`}>
        <Icon size={18} /> {label}</NavLink>)}</nav>
      <div className="sidebar-profile" data-testid="current-user-profile">
        <div className="avatar">{user.profile_photo_url ? <img src={absoluteMedia(user.profile_photo_url, user.profile_photo_updated_at)} alt={user.name} /> : user.name.charAt(0)}</div><div><strong>{user.name}</strong><span>{user.role === "coach" ? "Coach" : "Atleta"}</span></div>
        <button onClick={signOut} title="Esci" data-testid="logout-button"><LogOut size={18} /></button>
      </div>
    </aside>
    {open && <button className="nav-overlay" onClick={() => setOpen(false)} data-testid="navigation-overlay" aria-label="Chiudi menu" />}
    <main className="main-area">
      <header className="topbar">
        <button className="menu-button" onClick={() => setOpen(true)} data-testid="open-navigation-button"><Menu /></button>
        <p data-testid="user-greeting">Ciao, <strong>{user.name.split(" ")[0]}</strong></p>
        <div className="notification-wrap">
          <button className="notification-button" onClick={showNotices} data-testid="notifications-button"><Bell size={20} />
            {notifications.unread > 0 && <span data-testid="unread-notifications-count">{notifications.unread}</span>}</button>
          {noticeOpen && <div className="notifications-panel" data-testid="notifications-panel">
            <h3 data-testid="notifications-title">Notifiche</h3>
            {notifications.items.length ? notifications.items.slice(0, 6).map((item) => <button key={item.id} className="notice" onClick={() => { setNoticeOpen(false); if (item.url) navigate(item.url); }} data-testid={`notification-${item.id}`}>
              <strong>{item.title}</strong><p>{item.message}</p></button>) : <p data-testid="notifications-empty">Nessuna notifica.</p>}
          </div>}
        </div>
      </header>
      <div className="page-content">{children}</div>
    </main>
  </div>;
}